module.exports = __webpack_public_path__ + "img/ug.b408dce8.svg";